<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-11-11 09:44:20
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-02-06 15:56:54
-->

<template>
  <div>
    <mobile v-if="device == 'm'" />
    <pc v-if="device == 'pc'" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import pc from './pc'
import mobile from './m'
export default {
  components: {
    pc,
    mobile
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['device', 'language'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
  },
  destroyed () {
  }
}
</script>
